import { Link, useLocation } from 'react-router-dom';

import { Popover } from 'antd';
const joinBtn = (
  <div className="qrcode-dropdown"> 
             <div className="qrcode-image">
                <img src="/image/scan.png" alt="二维码" />
              </div>
              <div className="qrcode-desc">扫描二维码添加客服微信</div>
          </div>
);

export function Header() { 
  const location = useLocation();
  const isActiveAbout = location.pathname === '/about';
  const isActiveCooperation = location.pathname === '/cooperation';

  return (
    <div className="component-header">
      <div className="header-left">
        <Link to="/" className="logo-link">
          <div className="company-name">怀远模玩文化有限公司</div>
          <div className="logo-group">
            <div className="logo">
              <img src="/image/logo.png" alt="" />
            </div>
            <div className="name">呱呱模玩</div>
          </div>
        </Link>
      </div>
      <div className="header-center">
        <Link to="/about" className={`nav-link ${isActiveAbout ? 'active' : ''}`}>关于我们</Link>
        <Link to="/cooperation" className={`nav-link ${isActiveCooperation ? 'active' : ''}`}>商业合作</Link>
      </div>
      <div className="header-right">
        <Popover content={joinBtn}  >
               <button 
          className={`join-btn `}  
        >
          加入我们
        </button>
            </Popover> 
      </div>
    </div>
  );
}
